import i18n from "i18next";

/**
 * Utility for translating text outside React components
 * Uses i18n instance directly instead of useTranslation hook
 */
export const translate = (key: string, options?: any): string => {
  return i18n.t(key, options) as string;
};

/**
 * Short alias for translate function
 */
export const _t = translate;

/**
 * Utility for translating validation errors
 */
export const translateValidationError = (key: string, options?: any): string => {
  return translate(`${key}`, options);
};
